import type { MessageLocale, ProductionLocale } from './locales';

export const SIGNUP_LANGUAGE_METADATA_KEY = 'preferred_language_tag' as const;

/**
 * Signup language is an explicit product choice, never passive browser
 * detection. Only a public URL is authoritative: `/es` selects neutral
 * Spanish and the unprefixed public URL selects English. Native/non-URL
 * signup omits the preference so post-profile device CAS can keep `es-MX`,
 * `es-ES`, or another exact supported regional tag.
 */
export function resolveExplicitSignupLanguageTag({
    authMode,
    publicUrlAuthoritative,
    messageLocale,
}: {
    authMode: 'signin' | 'signup';
    publicUrlAuthoritative: boolean;
    messageLocale: MessageLocale;
}): ProductionLocale | null {
    if (authMode !== 'signup' || !publicUrlAuthoritative) return null;
    if (publicUrlAuthoritative && messageLocale === 'es') return 'es';
    return 'en';
}

export function buildExplicitSignupLanguageMetadata(input: Parameters<
    typeof resolveExplicitSignupLanguageTag
>[0]): Partial<Record<typeof SIGNUP_LANGUAGE_METADATA_KEY, ProductionLocale>> {
    const languageTag = resolveExplicitSignupLanguageTag(input);
    return languageTag ? { [SIGNUP_LANGUAGE_METADATA_KEY]: languageTag } : {};
}
